import { useRef } from 'react';
import { useCallbackOne as useStableCallback } from 'use-memo-one';
import { useAtomEffect } from '../../modernization-common/hooks/useAtomEffect';
import type { StudioRef } from '../component/studio';
import { focusedSuggestionAtom } from '../components/review-suggestions-panel/atoms/focused-suggestion-atom';
export const useStudioRef = () => {
  const studioRef = useRef<StudioRef>(null);
  useAtomEffect(useStableCallback((get, _set) => {
    const focusedSuggestion = get(focusedSuggestionAtom);
    const suggestionOptions = focusedSuggestion?.meta?.[focusedSuggestion.category];
    if (focusedSuggestion && suggestionOptions && 'startIndex' in suggestionOptions) {
      studioRef.current?.selectAnnotation(suggestionOptions.startIndex, focusedSuggestion.id);
    }
  }, []));
  return studioRef;
};